import ozSeoWidgetsGroup from './oz-seo-widgets-group'

export default ozSeoWidgetsGroup
